export const domParser = new DOMParser();
